import { FC, useEffect } from 'react';
import { FilterVM, ICategoryNavbar, NavbarElementType } from '../../../common/view-model';
import './NavbarCategoryComponent.scss';
import { NavbarOverlayComponent } from '../navbar-overlay/NavbarOverlayComponent';
import { isCurrentUserAnonymous } from '../../../helpers/authenticationHelper';
import { publicProductDiscoveryActions } from '../../../common/constants';
import cn from 'classnames';
import { useNavigate } from 'react-router';
import { useAppDispatch } from '../../../redux/store';
import { SearchActions } from '../../../redux/search/SearchActions';

interface INavbarCategoryComponentProps {
	handleAddCategoryFilter: (filter: FilterVM) => void;
	navbarCategoryElements: ICategoryNavbar[];
	categoryTab?: ICategoryNavbar;
	setCategoryTab: (category?: ICategoryNavbar) => void;
	setCloseOverlay: (setCurrentCategory: () => void) => void;
	handleAddFilterFromNavbar: (filter: FilterVM[]) => void;
	handleAddBizFromNavbar: (filter: FilterVM[]) => void;
	registerUserClickEvent: (event: string) => void;
	hasClickedOutsideBar: boolean;
	eventName: string;
	user: any;
	productsPageUrl: string;
	allCategories: FilterVM[];
}

export const NavbarCategoryComponent: FC<INavbarCategoryComponentProps> = ({
	handleAddCategoryFilter,
	navbarCategoryElements,
	categoryTab,
	setCategoryTab,
	setCloseOverlay,
	handleAddFilterFromNavbar,
	handleAddBizFromNavbar,
	registerUserClickEvent,
	hasClickedOutsideBar,
	eventName,
	user,
	productsPageUrl,
	allCategories
}) => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	useEffect(() => {
		setCloseOverlay(() => setCategoryTab(undefined));
	}, []);
	const handleCategoryNavbarClick = (element: ICategoryNavbar) => {
		if (element.id === NavbarElementType.ALL_CATEGORIES) {
			setCategoryTab(undefined);
			dispatch(SearchActions.setSearchTerm(undefined));
			navigate('/products');
			return;
		}
		setCategoryTab(element);
		if (isCurrentUserAnonymous()) {
			registerUserClickEvent(publicProductDiscoveryActions.CLICK_CATEGORY_TOP_NAVBAR);
		}
	};

	const customClasses = (element: ICategoryNavbar) => {
		return cn('category-item', {
			'event-text': element.id === NavbarElementType.EVENT,
			active: categoryTab?.id == element.id,
			'business-provider': element.id === NavbarElementType.BUSINESS_SERVICE
		});
	};
	return (
		<>
			<div className='category-navbar'>
				{navbarCategoryElements.map((element: ICategoryNavbar) =>
					element.id !== NavbarElementType.BUSINESS_SERVICE ? (
						<div
							className={customClasses(element)}
							key={element.id}
							onClick={() => handleCategoryNavbarClick(element)}
						>
							{element.name}
						</div>
					) : (
						<div
							className={customClasses(element)}
							key={element.id}
							onClick={() => handleCategoryNavbarClick(element)}
						>
							<div className='confetti'></div>
							<span>{element.name}</span>
							<div className='confetti'></div>
						</div>
					)
				)}
			</div>
			{categoryTab && (
				<NavbarOverlayComponent
					handleAddCategoryFilter={handleAddCategoryFilter}
					categoryTab={categoryTab}
					setCategoryTab={setCategoryTab}
					handleAddFilterFromNavbar={handleAddFilterFromNavbar}
					registerUserClickEvent={registerUserClickEvent}
					handleBizFilterFromNavbar={handleAddBizFromNavbar}
					hasClickedOutsideBar={hasClickedOutsideBar}
					eventName={eventName}
					user={user}
					productsPageUrl={productsPageUrl}
					allCategories={allCategories}
				/>
			)}
		</>
	);
};
